import { t } from "@/i18n-js/instance";
import { TRIGGER_RESOURCE_TYPE } from "../../../constants";
import type { EventOption } from "../types";
import { PaywallResource } from "./shared/PaywallResource";
import { WhichPaywallSelector } from "./shared/WhichPaywallSelector";

export const memberPurchased: Readonly<EventOption> = {
  label: t(
    "settings.workflows.form.events.community_member_purchases_paywall.title",
  ),
  value: "community_member_purchases_paywall",
  group: t("settings.workflows.form.event_groups.paywalls"),
  description: t(
    "settings.workflows.form.events.community_member_purchases_paywall.description",
  ),
  resource: TRIGGER_RESOURCE_TYPE.PAYWALL,
  formComponent: WhichPaywallSelector,
  viewComponent: PaywallResource,
  icon: "paywall",
};
